export const SECTIONS = {
  name: 'name',
  location: 'location',
  questions: 'questions',
  appearance: 'appearance',
  invitation: 'invitation',
  targeting: 'targeting',
  behavior: 'behavior',
  forwarding: 'forwarding',
  review: 'review',
  sharing: 'sharing',
};

export const LOCATION_AGNOSTIC_SECTIONS = [
  SECTIONS.name,
  SECTIONS.location,
  SECTIONS.questions,
  SECTIONS.appearance,
  SECTIONS.forwarding,
  SECTIONS.review,
  SECTIONS.behavior,
];
